import { reservation as reservationMixin } from './reservation'
import { mapState } from 'vuex';

export const checkout = {
  mixins: [
    reservationMixin
  ],

  data() {
    return {
      isUserLoggedIn: window.heb.data.user.isLoggedIn,
      isUserRecognized: window.heb.data.user.isRecognized,
    }
  },

  computed: {
    ...mapState({
      ageVerificationRequired: state => state.cart.ageVerificationRequired,
    }),
    // Frontend Validation for the Place Order button
    checkoutValidation () {
      // User must have items in the cart
      if (this.$store.state.cart.commerceItemCount < 1) {
        return {
          success: false,
          errorCode: 'CART_EMPTY',
          errorMessage: 'Your cart is empty.'
        }
      }

      // Check that curbside pickup users have a timeslot
      if (this.isInvalidTimeslot) {
        return {
          success: false,
          errorCode: 'INVALID_TIMESLOT',
          errorMessage: 'Please choose a time slot to proceed to checkout.'
        }
      }

      return { success: true }
    },
    isInvalidTimeslot() {
      return (
        !this.$store.state.reservation.timeslotId ||
        this.$store.state.reservation.expiration.isPassed
      );
    }
  },

  methods: {
    proceedToCheckout: function () {
      this.$bvModal.hide('proceed-to-checkout-modal');

      if (this.checkoutValidation.success) {
        if (this.isUserLoggedIn || this.isUserRecognized) {
          // Send user to precheckout
          this.$router.push({ path: '/precheckout' })
        } else if (this.ageVerificationRequired) {
          // Send user to age verification login flow
          window.location = '/my-account/login?source=curbsideCartAgeVerificationRequired'
        } else {
          // Send user to checkout login flow
          window.location = '/my-account/login?source=curbsideCart'
        }
      } else {
        var error = {
          type: 'general',
          icon: 'fa-exclamation-triangle', // Accepts fontawesome 4 icon names.
          message: this.checkoutValidation.errorMessage, // text or html
          id: this.checkoutValidation.errorCode,
          code: '000',
          variant: 'danger' // warn, info, danger
        }
        this.$store.commit('errors/CLEAR_ERRORS')
        this.$store.commit('errors/PUSH_ERROR', error)

        // If invalid timeslot, open timeslot picker
        if (this.checkoutValidation.errorCode === 'INVALID_TIMESLOT') {
          this.showModal('change-timeslot-modal', {
            redirectPath: '/precheckout'
          })
        }
      }
    }
  }
}